import React from "react";
import MarketoForm from '../marketo/marketoForm';
import '../../sass/components/flexibleModules/_components.marketoFormSectionModule.scss';

const MarketoFormSectionModule = ({ data }) => {
    return (
        <div className={`cp-marketoFormSectionModule ${data.overrideClass ? data.overrideClass : "l-noOverride"}`}>
            <div className="cp-marketoFormSectionModule__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.marketoFormSectionId &&
                    <MarketoForm ctabgcolor={data.heroSectionWithFormCtaButtonColor} data={data} formID={data.marketoFormSectionId} formSubmitThankYouPage={data.marketoThankYouPage} formSubmitMessage={data.marketoFormThankYouMessage} />
                }
            </div>
        </div>
    );
}

export default MarketoFormSectionModule;